// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3NPJ2","disabled":"FileBtn_disabled__1aiod","warn":"FileBtn_warn__2VkhV","fade":"FileBtn_fade__4tMti"};